import {styleForHeader} from '../../style.js';

export const GridColumns = [
    { field: 'id', hide: true},
    { field: 'code', width: 150, headerAlign:'center', text:'DEPARTMAN KODU',
        renderHeader: () => styleForHeader('DEPARTMAN KODU')
    },
    { field: 'companyId', width: 250, headerAlign:'center', text:'FİRMA NUMARASI',
        renderHeader: () => styleForHeader('FİRMA NUMARASI')
    },
    { field: 'description', width: 250, headerAlign:'center', text:'AÇIKLAMA',
        renderHeader: () => styleForHeader('AÇIKLAMA'),
    },        
    { field: 'recordStatus', hide: true}
];